module.exports = require('./helpers/bundle-url').getBundleURL('2c9kW') + "../images/circle.13ecd4ba.svg";